import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMedicalPaper = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.86333 2.62501C5.51699 2.61077 5.1791 2.73429 4.9236 2.96855C4.6681 3.20281 4.51579 3.52873 4.5 3.87501V20.125C4.51579 20.4713 4.6681 20.7972 4.9236 21.0315C5.1791 21.2657 5.51699 21.3893 5.86333 21.375H18.1367C18.483 21.3893 18.8209 21.2657 19.0764 21.0315C19.3319 20.7972 19.4842 20.4713 19.5 20.125V6.89251C19.4987 6.72559 19.4625 6.56079 19.3937 6.40868C19.325 6.25657 19.2252 6.12049 19.1008 6.00918L15.8083 2.99084C15.5436 2.75323 15.1999 2.62279 14.8442 2.62501H5.86333Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 13.25C15.75 13.0842 15.6842 12.9253 15.5669 12.8081C15.4497 12.6908 15.2908 12.625 15.125 12.625H13.25V10.75C13.25 10.5842 13.1842 10.4253 13.0669 10.3081C12.9497 10.1908 12.7908 10.125 12.625 10.125H11.375C11.2092 10.125 11.0503 10.1908 10.9331 10.3081C10.8158 10.4253 10.75 10.5842 10.75 10.75V12.625H8.875C8.70924 12.625 8.55027 12.6908 8.43306 12.8081C8.31585 12.9253 8.25 13.0842 8.25 13.25V14.5C8.25 14.6658 8.31585 14.8247 8.43306 14.9419C8.55027 15.0592 8.70924 15.125 8.875 15.125H10.75V17C10.75 17.1658 10.8158 17.3247 10.9331 17.4419C11.0503 17.5592 11.2092 17.625 11.375 17.625H12.625C12.7908 17.625 12.9497 17.5592 13.0669 17.4419C13.1842 17.3247 13.25 17.1658 13.25 17V15.125H15.125C15.2908 15.125 15.4497 15.0592 15.5669 14.9419C15.6842 14.8247 15.75 14.6658 15.75 14.5V13.25Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5 2.625V6.19667C14.5002 6.57542 14.6508 6.93859 14.9186 7.20641C15.1864 7.47422 15.5496 7.62478 15.9283 7.625H19.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMedicalPaper.displayName = 'SvgMedicalPaper';
export default SvgMedicalPaper;
